import axios from "axios";
import ElementUi, { Loading, Message } from "element-ui";
import { baseURL } from "./url";
import router from "@/router";
let loading = null;
const close = () => {
  setTimeout(() => {
    loading && loading.close();
  }, 500);
};
// loading = Loading.service()
class Axios {
  constructor(props) {
    this.axios = null;
    this.init();
  }
  init() {
    const config = {
      baseURL,
      timeout: 30000,
      headers: {
        common: {
          "Content-Type": "application/x-www-form-urlencoded",
          authorization: localStorage.getItem("token")
            ? "bearer " + localStorage.getItem("token")
            : "",
          userId: localStorage.getItem("id")
            ? localStorage.getItem("id")
            : "xxx",
          pageType: localStorage.getItem("pageType")
        }
      }
    };
    this.axios = axios.create(config);
    this.axios.interceptors.request.use(
      function(config) {
        return config;
      },
      function(error) {
        // 对请求错误做些什么
        close();
        return Promise.reject(error);
      }
    );
    // 添加响应拦截器
    this.axios.interceptors.response.use(
      function(response) {
        // 对响应数据做点什么
        close();
        // if(response.data.code==213||response.data.code==400){
        //   Message({
        //     message: response.data.msg,
        //     type: "warning"
        //   });
        //   router.push('/login')
        // }
        return response;
      },
      function(error) {
        // ElementUi.Notification.error({
        //     title: error.response.status,
        //     message:error.response.data.errors[0].message
        //  })

        close();
        return Promise.reject(error);
      }
    );
  }
  get(url, config) {
    return this.axios.get(url, { ...config });
  }
  post(url, data, config) {
    return this.axios.post(url, data, { ...config });
  }
  async all(props) {
    return await axios.all([...props]);
  }
}

export default new Axios();



// WEBPACK FOOTER //
// ./src/utils/axios.js